<template>
  <div class="mb-3">
    <label class="form-label"
      >{{ data.label
      }}<span
        class="asterisk"
        :class="mode == 'write' ? 'red' : ''"
        v-if="data.mandatory"
        >*</span
      ></label
    >
    <template v-if="mode == 'write'">
      <input
        :type="
          data.questionKey == 'bkger_email'
            ? 'email'
            : data.questionKey == 'bkger_tel'
            ? 'tel'
            : 'text'
        "
        class="form-control"
        :id="data.id"
        autocomplete="off"
        :class="isValid ? '' : 'error'"
        v-model="inputVal"
        @change.stop="checkValid()"
        @keypress="checkNumberKey($event)"
      />
      <div class="form-text error_msg" v-if="!isValid && mode == 'write'">
        {{ error_msg }}
      </div></template
    >
    <template v-else>
      <div class="input_answer">
        {{
          data.value != undefined && data.value.trim() != ""
            ? data.value
            : "未輸入"
        }}
      </div>
    </template>
  </div>
</template>

<script>
import { ref, inject, onMounted, onBeforeUnmount } from "vue";
import useEventBus from "@/config/eventBus";

export default {
  props: {
    data: {
      type: Object,
      required: true,
    },
    mode: {
      type: String,
      required: true,
    },
  },
  setup(props) {
    const isValid = ref(true);
    const error_msg = ref(`必須輸入${props.data.label}！`);
    const eventBus = useEventBus();
    const emailRegex = inject("emailRegex");
    const inputVal = ref("");

    const checkValid = () => {
      if (props.data.questionKey.trim() != "bkger_tel") {
        inputVal.value = inputVal.value.trim();
      }
      if (props.mode == "write" && props.data.mandatory) {
        if (props.data.questionKey.trim() == "bkger_email") {
          error_msg.value = `必須輸入有效${props.data.label}！`;
          inputVal.value.match(emailRegex)
            ? (isValid.value = true)
            : (isValid.value = false);
        } else {
          inputVal.value == ""
            ? (isValid.value = false)
            : (isValid.value = true);
        }
      }
      if (props.mode == "write") {
        setTimeout(() => {
          eventBus.emit("inputValue", {
            id: props.data.id,
            val: inputVal.value,
          });
        }, 50);
      }
    };

    const checkNumberKey = ($event) => {
      if (props.data.questionKey.trim() == "bkger_tel") {
        let keyCode = $event.keyCode ? $event.keyCode : $event.which;
        if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) {
          // 46 is dot
          $event.preventDefault();
        }
      }
    };

    onMounted(() => {
      //console.log(props.data);
      inputVal.value = props.data.value;

      eventBus.on("checkValid", () => {
        document
          .getElementById(props.data.id)
          .dispatchEvent(new Event("change"));
      });
    });

    onBeforeUnmount(() => {
      eventBus.off("checkValid");
    });

    return {
      inputVal,
      error_msg,
      isValid,
      checkValid,
      checkNumberKey,
    };
  },
};
</script>
